import { render, staticRenderFns } from "./SortableTable.vue?vue&type=template&id=4a9dbf3e&"
import script from "./SortableTable.vue?vue&type=script&lang=ts&"
export * from "./SortableTable.vue?vue&type=script&lang=ts&"
import style0 from "./SortableTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports